module.exports = __webpack_public_path__ + "img/2.da7f33be.png";